import { render } from "./pb-agenda.vue?vue&type=template&id=4be60424"
import script from "./pb-agenda.vue?vue&type=script&lang=js"
export * from "./pb-agenda.vue?vue&type=script&lang=js"

import "./pb-agenda.vue?vue&type=style&index=0&id=4be60424&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__